export enum SelfOnboardingCreateAccountSector {
  HOSPITALITY_AND_FOOD_SERVICES = 'HOSPITALITY_AND_FOOD_SERVICES',
  REAL_ESTATE_ACTIVITIES = 'REAL_ESTATE_ACTIVITIES',
  CONSTRUCTION = 'CONSTRUCTION',
  MEDICAL_AND_HEALTH_ACTIVITIES = 'MEDICAL_AND_HEALTH_ACTIVITIES',
  ECOMMERCE_AND_CONSUMER_GOODS = 'ECOMMERCE_AND_CONSUMER_GOODS',
  WHOLESALE_AND_RETAIL_TRADE = 'WHOLESALE_AND_RETAIL_TRADE',
  FINANCIAL_AND_INSURANCE_ACTIVITIES = 'FINANCIAL_AND_INSURANCE_ACTIVITIES',
  AGRICULTURE_FORESTRY_AND_FISHING = 'AGRICULTURE_FORESTRY_AND_FISHING',
  TRANSPORTATION_LOGISTIC_AND_STORAGE = 'TRANSPORTATION_LOGISTIC_AND_STORAGE',
  MANUFACTURING_AND_INDUSTRIAL_SERVICES = 'MANUFACTURING_AND_INDUSTRIAL_SERVICES',
  ENERGY_POWER_AND_RENEWABLES = 'ENERGY_POWER_AND_RENEWABLES',
  EDUCATION = 'EDUCATION',
  ARTS_ENTERTAINMENT_AND_RECREATION = 'ARTS_ENTERTAINMENT_AND_RECREATION',
  PROFESSIONAL_AND_CONSULTANCY_ACTIVITIES = 'PROFESSIONAL_AND_CONSULTANCY_ACTIVITIES',
  INFORMATION_AND_COMMUNICATION = 'INFORMATION_AND_COMMUNICATION',
  OTHER_SERVICES = 'OTHER_SERVICES'
}
